const RIDE_TYPES = {
  SHOW: {
    name: "Show",
    rideCredit: {
      countLine: `You've watched`,
      againAction: `Watch again?`,
      removeAction: `Remove a watch`,
      claimCredit: `Claim Watch Credit`,
    },
  },
  RIDE: {
    name: "Ride",
    rideCredit: {
      countLine: `You've ridden`,
      againAction: `Ride again?`,
      removeAction: `Remove a ride`,
      claimCredit: `Claim Ride Credit`,
    },
  },
  CHARACTER_MEET: {
    name: "Character Meet",
    rideCredit: {
      countLine: `You've met`,
      againAction: `Meet again?`,
      removeAction: `Remove a meet`,
      claimCredit: `Claim Character Meet Credit`,
    },
  },
  WALK_THROUGH: {
    name: "Walk Through",
    rideCredit: {
      countLine: `You've walked through`,
      againAction: `Walk through again?`,
      removeAction: `Remove a walk through`,
      claimCredit: `Claim Walk Through Credit`,
    },
  },
  PLAYGROUND: {
    name: "Playground",
    rideCredit: {
      countLine: `You've played here`,
      againAction: `Play again?`,
      removeAction: `Remove a play`,
      claimCredit: `Claim Playground Credit`,
    },
  },
  TRANSPORTATION: {
    name: "Transportation",
    rideCredit: {
      countLine: `You've ridden`,
      againAction: `Ride again?`,
      removeAction: `Remove a ride`,
      claimCredit: `Claim Transportation Credit`,
    },
  },
  STREET_PERFORMANCE: {
    name: "Street Performance",
    rideCredit: {
      countLine: `You've watched`,
      againAction: `Watch again?`,
      removeAction: `Remove a watch`,
      claimCredit: `Claim Street Performance Credit`,
    },
  },
  SPECTACULAR: {
    name: "Spectacular",
    rideCredit: {
      countLine: `You've watched`,
      againAction: `Watch again?`,
      removeAction: `Remove a watch`,
      claimCredit: `Claim Spectacular Credit`,
    },
  },
  PARADE: {
    name: "Parade",
    rideCredit: {
      countLine: `You've watched`,
      againAction: `Watch again?`,
      removeAction: `Remove a watch`,
      claimCredit: `Claim Parade Credit`,
    },
  },
  WATER_SLIDE: {
    name: "Waterslide",
    rideCredit: {
      countLine: `You've slid`,
      againAction: `Slide again?`,
      removeAction: `Remove a slide`,
      claimCredit: `Claim Water Slide Credit`,
    },
  },
  SLIDE: {
    name: "Slide",
    rideCredit: {
      countLine: `You've slid`,
      againAction: `Slide again?`,
      removeAction: `Remove a slide`,
      claimCredit: `Claim Slide Credit`,
    },
  },
  ANIMAL_EXHIBIT: {
    name: "Animal Exhibit",
    rideCredit: {
      countLine: `You've viewed`,
      againAction: `View again?`,
      removeAction: `Remove a view`,
      claimCredit: `Claim Animal Exhibit Credit`,
    },
  },
  RETAIL: {
    name: "Retail",
    rideCredit: {
      countLine: `You've shopped`,
      againAction: `Shop again?`,
      removeAction: `Remove a shop`,
      claimCredit: `Claim Shop Credit`,
    },
  },
  RESTROOM: {
    name: "Restroom",
    rideCredit: {
      countLine: `You've gone`,
      againAction: `Claim again?`,
      removeAction: `Remove a restroom`,
      claimCredit: `Claim restroom Credit`,
    },
  },
  OTHER: {
    name: "Other",
    rideCredit: {
      countLine: `You've experienced this`,
      againAction: `Experience again?`,
      removeAction: `Remove an experience`,
      claimCredit: `Claim Credit`,
    },
  },
};

export default RIDE_TYPES;
